<template>
    <div class="page">
        <z-edit-alarm-config ref="editAlarmConfig" @updateSuccess="refresh"></z-edit-alarm-config>

        <div class='section-list content'>
            <a-spin :spinning="isLoading" :tip="$t('global.loading')">
                <a-table :columns="columns" :dataSource="data" :pagination="pagination">
                    <template slot="notice" slot-scope="text,record">
                        <a-badge status="default" :text="$t('global.none')"  v-if="!record.noticeTypes || record.noticeTypes.length == 0"/>
                        <template v-else v-for="(type, index) in record.noticeTypes">
                            <a-tag :key="index" color="blue" v-if="type == 1">{{$t('alarm.sms')}}</a-tag>
                            <a-tag :key="index" color="blue" v-if="type == 2">{{$t('alarm.email')}}</a-tag>
                            <a-tag :key="index" color="blue" v-if="type == 3">{{$t('alarm.webPage')}}</a-tag>
                        </template>
                    </template>
                    <template slot="name" slot-scope="text, record">
                      <div>
                        <i class="icon-alarm icon-lg">
                          <zx-icon :type="computedAlarmIcon(record.alarmCode)" />
                        </i>
                        {{$t(`alarm.${text}`)}}
                      </div>
                    </template>
                    <template slot="level" slot-scope="text">
                        <a-tag color="blue" v-if="text == 1">{{$t('global.event')}}</a-tag>
                        <a-tag color="yellow" v-if="text == 2">{{$t('global.noramlAlarm')}}</a-tag>
                        <a-tag color="orange" v-if="text == 3">{{$t('global.importantAlarm')}}</a-tag>
                        <a-tag color="red" v-if="text == 4">{{$t('global.fearfulAlarm')}}</a-tag>
                    </template>
                    <template slot="threshold" slot-scope="text,record">
                      <span v-if="record.alarmCode == 10002">{{$t('alarm.lessThan') + record.threshold + ',' + $t('alarm.greaterThan') + record.secondThreshold}}</span>
                      <span v-if="record.alarmCode == 10006">{{$t('alarm.lessThan') + record.threshold + $t('global.temperature') + ',' + $t('alarm.greaterThan') + record.secondThreshold + $t('global.temperature')}}</span>
                      <span v-if="text && record.alarmCode != 10002 && record.alarmCode != 10006 && record.alarmCode != 10007">{{record.threshold * 1 > 100 ? formatTime(record.threshold * 1) : record.threshold}}</span>
                       <span v-if="record.alarmCode == 10007">{{record.threshold + $t('global.secondOnce')}}</span>
                      <a-badge status="error" :text="$t('global.nonsupport')" v-if="text == false"/>
                    </template>
                    <template slot="status" slot-scope="text">
                        <a-badge status="processing" :text="$t('global.enable')" v-if="text == true"/>
                        <a-badge status="default" :text="$t('global.disable')" v-if="text == false"/>
                    </template>
                    <template slot="ringType" slot-scope="text">
                        <a-tag color="#ccc" v-if="text == 1">{{$t('alarm.ringNone')}}</a-tag>
                        <a-tag color="blue" v-if="text == 2">{{$t('alarm.ringOnce')}}</a-tag>
                        <a-tag color="red" v-if="text == 3">{{$t('alarm.ringAlways')}}</a-tag>
                    </template>
                    <template slot="repeatFlag" slot-scope="text">
                        <a-badge status="success" :text="$t('global.yes')" v-if="text == true"/>
                        <a-badge status="error" :text="$t('global.no')" v-if="text == false"/>
                    </template>
                    <template slot="autoDispose" slot-scope="text">
                        <a-badge status="success" :text="$t('global.yes')" v-if="text == true"/>
                        <a-badge status="error" :text="$t('global.no')" v-else-if="text == false"/>
                        <a-badge status="default" :text="$t('global.nonsupport')" v-else />
                    </template>
                    <template slot="edit" slot-scope="text,record">
                        <a href="javascript:;" @click="editConfig(record)">{{$t('global.edit')}}</a>
                    </template>
                </a-table>
            </a-spin>
        </div>
    </div>
</template>

<script>
    import config from '@/config'
    import ZEditAlarmConfig from '@/views/alarm/EditAlarmConfig.vue'
    import moment from 'moment'
    import {computedAlarmIcon} from '../../utils/homeFn'
    export default {
        data() {
            return {
                isLoading: false,
                pagination:{pageSize: 10},
                data: [],
                alarmConfig: null,
                editAlarmConfig: false,
            }
        },
        computed: {
          columns () {
            return [
              {
                  "title": this.$t('global.alarmType'),
                  "dataIndex": "name",
                  "key": "name",
                  "left": true,
                  "scopedSlots": {
                      "customRender": "name"
                  },
              },
              {
                  "title": this.$t('global.alarmLevel'),
                  "dataIndex": "level",
                  "key": "level",
                  "scopedSlots": {
                      "customRender": "level"
                  },
              },
              {
                  "title": this.$t('alarm.alarmThreshold'),
                  "dataIndex": "enabledThreshold",
                  "key": "enabledThreshold",
                  "scopedSlots": {
                      "customRender": "threshold"
                  },
              },
              {
                  "title": this.$t('alarm.repeatable'),
                  "dataIndex": "repeatFlag",
                  "key": "repeatFlag",
                  "scopedSlots": {
                      "customRender": "repeatFlag"
                  },
              },
              {
                  "title": this.$t('alarm.autoRecovery'),
                  "dataIndex": "autoDispose",
                  "key": "autoDispose",
                  "scopedSlots": {
                      "customRender": "autoDispose"
                  },
              },
              {
                  "title": this.$t('global.alarmStatu'),
                  "dataIndex": "enabled",
                  "key": "enabled",
                  "scopedSlots": {
                      "customRender": "status"
                  },
              },
              {
                  "title": this.$t('alarm.alarmNotice'),
                  "dataIndex": "noticeType",
                  "key": "noticeType",
                  "scopedSlots": {
                      "customRender": "notice"
                  },
              },
              {
                  "title": this.$t('alarm.ringType'),
                  "dataIndex": "ringType",
                  "key": "ringType",
                  "scopedSlots": {
                      "customRender": "ringType"
                  },
              },
            //   {
            //       "title": this.$t('global.alarmDescription'),
            //       "dataIndex": "message",
            //       "key": "message"
            //   },
              {
                  "title": this.$t('global.alarmAction'),
                  "key": 'action',
                  "scopedSlots": {
                      "customRender": "edit"
                  }
              }
          ]
          }
        },
        components: {
            ZEditAlarmConfig
        },
        methods:{
            computedAlarmIcon,
            formatTime (seconds) {
              let time
              if (seconds >= 12 * 60 * 60) {
                time = moment.duration({seconds: seconds}).humanize()
              } else {
                let hours = Math.floor(seconds / 3600) ? Math.floor(seconds / 3600) : ''
                let mins = Math.floor((seconds % 3600) / 60)
                if (hours && !mins) {
                  time =  hours + this.$t('global.hour')
                }
                if (!hours && mins) {
                  time =  mins + this.$t('global.minute')
                }
                if (hours && mins) {
                  time = hours ? hours + this.$t('global.hour') + mins + this.$t('global.minute') : mins + this.$t('global.minute')
                }
              }
              return time
            },
            refresh(){
                this.queryConfig()
            },
            editConfig(record){
                this.$refs["editAlarmConfig"].showModel(this.clone(record))
            },
            showTotal(total) {
                return '共'+ total + '条'
            },
            queryConfig(){
                this.isLoading = true
                this.$http.get(config.api.alarm_config_url).then((response) => {
                  // console.log(response)
                    if(response.code == 0){
                        this.data = []
                        // let _this = this
                        response.result.map((item) => {
                            let types = []
                            if(item.noticeType){
                                types.push(...item.noticeType.split(','))
                            }
                            this.data.push({
                                id: item.id,
                                name: item.alarmType.name,
                                enabledThreshold: item.alarmType.enabledThreshold,
                                threshold: item.threshold,
                                level: item.level,
                                enabled: item.enabled,
                                noticeTypes: types,
                                message: item.message,
                                repeatFlag: item.repeatFlag,
                                autoDispose: item.autoDispose,
                                alarmCode: item.alarmType.code,
                                ringType: item.ringType,
                                secondThreshold: item.secondThreshold,
                            })
                        })
                        console.log(this.data)
                        this.pagination.total = response.result.length
                    }
                    this.isLoading = false
                }).catch((err) => {
                    console.log(err)
                    this.isLoading = false
                })
            },
            clone(obj){
                if (null == obj || "object" != typeof obj) return obj;
                if (obj instanceof Date) {
                    let copy = new Date();
                    copy.setTime(obj.getTime());
                    return copy;
                }
                if (obj instanceof Array) {
                    let copy = [];
                    var len = obj.length;
                    for (var i = 0; i < len; ++i) {
                        copy[i] = this.clone(obj[i]);
                    }
                    return copy;
                }
                if (obj instanceof Object) {
                    let copy = {};
                    for (var attr in obj) {
                        if (obj.hasOwnProperty(attr)) copy[attr] = this.clone(obj[attr]);
                    }
                    return copy;
                }
                throw new Error("Unable to copy obj! Its type isn't supported.");
            }
        },
        created() {
            this.queryConfig()
        }
    }
</script>